<div class="acs-page">

  <!-- Loading State -->
  <div *ngIf="isLoading" class="acs-page__loading">
    <acs-loading-spinner size="large" message="Loading chapters data..."></acs-loading-spinner>
  </div>

  <!-- Error State -->
  <acs-alert 
    *ngIf="error" 
    type="error" 
    title="Error Loading Chapters"
    [message]="error" 
    [dismissible]="true"
    (dismissed)="error = null">
  </acs-alert>

  <!-- Main Content -->
  <div *ngIf="!isLoading" class="acs-page__content">
    
    <!-- Header Section -->
    <div class="acs-page-header">
      <div class="acs-page-header__title-section">
        <h1 class="acs-page-header__title">All Chapters</h1>
        <p class="acs-page-header__subtitle">
          Comprehensive view and management of all chapters in your organization. 
          <span class="acs-page-header__role" *ngIf="currentUser.FirstLast">Current user: {{ currentUser.FirstLast }} <ng-container *ngIf="userRole">({{ userRole }}) </ng-container></span>
        </p>
      </div>
    </div>

    <acs-summary 
      [summaryCards]="summaryCards"
      [gridColumns]="4"
      cardSize="medium"
      spacing="normal" />

    <!-- Bulk Actions Bar -->
    <div class="acs-bulk-actions" *ngIf="selectedChaptersRecords.length > 0">
      <div class="acs-bulk-actions__info">
        <span class="acs-bulk-actions__selection-count">
          {{ selectedChaptersRecords.length }} chapter{{ selectedChaptersRecords.length === 1 ? '' : 's' }} selected
        </span>
      </div>
      <div class="acs-bulk-actions__buttons">
        <acs-button 
          variant="primary" 
          size="small"
          (clicked)="publishAnnouncement()"
          [disabled]="isLoading">
          📢 Publish Announcement
        </acs-button>
        <acs-button 
          variant="primary" 
          size="small"
          [dropdown]="true"
          [dropdownOptions]="exportOptions"
          dropdownPosition="left"
          [disabled]="isLoading"
          (dropdownOptionSelected)="onExportOptionSelected($event)">
          📊 Export {{ selectedChaptersRecords.length > 0 ? 'Selected' : 'All' }}
        </acs-button>
        <acs-button 
          variant="text" 
          size="small"
          (clicked)="clearSelection()">
          Clear Selection
        </acs-button>
      </div>
    </div>

    <!-- Chapter Data Grid Section -->
    <div class="acs-grid-section">
      <div class="acs-grid-section__header">
        <h2 class="acs-grid-section__title">Chapter Directory</h2>
        <p class="acs-grid-section__description">
          Complete directory of all chapters with detailed information and management capabilities. 
          Select multiple chapters to perform bulk operations.
        </p>
        <p class="acs-grid-section__description">
          View all chapters with their current status and details. Click on any row to view chapter details.
        </p>
      </div>

      <div class="acs-grid-section__container">
        <acs-data-grid
          [serverSide]="true"
          #chaptersGrid
          [entityName]="entityName"
          entityAdapter="chapters"
          [columns]="gridColumns"
          [pageSize]="50"
          [currentPage]="1"
          [showPagination]="true"
          [showPageSizeSelector]="true"
          [pageSizeOptions]="[25, 50, 100, 250]"
          [sortable]="true"
          [filterable]="true"
          [enableDropdownFilters]="true"
          [searchable]="true"
          searchPlaceholder="Search chapters"
          [selectable]="'multiple'"
          [exportable]="true"
          [exportFilenamePrefix]="'all-chapters-directory'"
          [stickyHeader]="true"
          [autoLoad]="true"
          emptyText="No chapters found"
          (serverError)="onServerDataError($event)"
          (rowClick)="onGridRowClick($event)"
          (selectionChange)="onGridSelectionChange($event)"
          (export)="onGridExport($event)">
        </acs-data-grid>
      </div>
    </div>

    </div>
  

  <!-- Bulk Operation Modals -->
  <acs-announcement-modal
    [isOpen]="showAnnouncementModal"
    [selectedChapters]="selectedChaptersRecords"
    (modalClosed)="onAnnouncementModalClosed()"
    (announcementPublished)="onAnnouncementPublished($event)" />

</div>